import { styled } from '@mui/material';

export const PageTitle = styled('h1')({
  fontStyle: "normal",
  fontWeight: "700",
  fontSize: "24px",
  lineHeight: "34px",
  color: "#11192A",
  margin: 0
});
